<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>{{user.name}}</v-toolbar-title>
    </v-toolbar>
    <v-list>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Email adress</v-list-tile-title>
          <v-list-tile-sub-title v-html="user.email"></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Roles</v-list-tile-title>
          <v-list-tile-sub-title v-for="(role, j) in user.roles" :key="j">
            <span>{{ role }}</span>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-card-actions >
        <v-spacer></v-spacer>
        <v-btn :to="{name : 'Show User', params: {id : user.id}}">
          Show Details
        </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'UserCard',
  props: {
    user: Object,
  },
};
</script>
